import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { VideoSection } from '../components/VideoSection';
import { Benefits } from '../components/Benefits';
import { BusinessModel } from '../components/BusinessModel';
import { Calculator } from '../components/Calculator';
import { About } from '../components/About';
import { Testimonials } from '../components/Testimonials';
import { GoogleReviews } from '../components/GoogleReviews';
import { Faq } from '../components/Faq';
import { NextStep } from '../components/NextStep';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { faqs } from '../data/content';
import { useSeo } from '../hooks/useSeo';
const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [{
    '@type': 'Organization',
    '@id': 'https://hotsalesgirls.com/#organization',
    name: 'Hot Sales Girls Academy',
    url: 'https://hotsalesgirls.com/',
    logo: 'https://cdn.magicpatterns.com/uploads/dVxge7E5WrZsG2Xk4nm9RJ/image.png',
    description: 'Online-Academy für Frauen, die als Premium-Closerin im Remote Sales starten und hochpreisige Angebote authentisch verkaufen möchten.',
    sameAs: ['https://www.instagram.com/tina_xla/', 'https://www.tiktok.com/@tina_xla', 'https://www.youtube.com/@tina_xla']
  }, {
    '@type': 'Course',
    name: 'Hot Sales Girls Academy',
    description: 'In 8 Wochen zur Premium-Closerin: Verkaufsgespräche auf Augenhöhe führen, hochpreisige Angebote abschließen und ortsunabhängig arbeiten – auch ohne Vorkenntnisse.',
    inLanguage: 'de',
    provider: {
      '@id': 'https://hotsalesgirls.com/#organization'
    },
    hasCourseInstance: {
      '@type': 'CourseInstance',
      courseMode: 'online',
      courseWorkload: 'P8W'
    }
  }, {
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  }]
};
export function Home() {
  useSeo({
    title: 'Hot Sales Girls Academy | In 8 Wochen zur Premium-Closerin im Remote Sales',
    description: 'Lerne als Quereinsteigerin, hochpreisige Angebote authentisch zu verkaufen: 500–1.500€ Provision pro Abschluss, ortsunabhängig arbeiten und ohne eigenes Produkt starten. Jetzt kostenlosen Guide sichern.',
    path: '/'
  }, structuredData);
  return <div className="min-h-screen w-full overflow-x-hidden" data-id="element-542" data-mp="28c4fjleou9zg">
      <div className="pink-panel relative" data-id="element-543" data-mp="1tkm2nwh4kvkb">
        <div className="relative z-10" data-id="element-544" data-mp="1tjkohj4tbsyd">
          <Navbar data-id="element-545" data-mp="1yjgjwtzg2c2b" />
          <main data-id="element-546" data-mp="1yixcw8bc1832">
            <Hero data-id="element-547" data-mp="1yif82naltljj" />
            <VideoSection data-id="element-548" data-mp="2ma2sqnh9w0dd" />
            <Benefits data-id="element-549" data-mp="2m9t0suco3j51" />
            <BusinessModel data-id="element-550" data-mp="2m9awrbjrk0mk" />
            <About data-id="element-551" data-mp="2m7zu5f220yx1" />
            <Calculator data-id="element-552" data-mp="2r0sxbyhvjz70" />
            <Testimonials data-id="element-553" data-mp="2r12mxkz0c4c6" />
            <GoogleReviews data-id="element-554" data-mp="2r2ds9p83pk5e" />
            <Faq data-id="element-555" data-mp="2r2m6pljvgxip" />
            <NextStep data-id="element-556" data-mp="flkapc7z5raj" />
          </main>
          <Footer data-id="element-557" data-mp="fkixp27eeuq6" />
        </div>
      </div>
      <CookieBanner data-id="element-558" data-mp="fjhegag8b1xd" />
    </div>;
}